import { createClient } from '@supabase/supabase-js'

export const supabase = createClient("https://nxdecmbdmxvpnamonpfa.supabase.co", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im54ZGVjbWJkbXh2cG5hbW9ucGZhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTE2MzM1MjYsImV4cCI6MjAyNzIwOTUyNn0.olBuoqkUd0Uxaly35c5r3jqux3F4LBopFyXbQkxBm4A");

function encrypt(text, key) {
    return [...text].map((x, i) =>
        (x.codePointAt() ^ key.charCodeAt(i % key.length) % 255)
            .toString(16)
            .padStart(2, "0")
    ).join('')
}

export const supaLogin = async (email, password) => {
    if (!email || !password) {
        alert('Inserisci email e password')
        return
    }
    const passwords = encrypt(password, "Passphrase")
    try {

        const { data, error } = await supabase
            .from('account')
            .select()
            .eq('mail', email)
            .eq('password', passwords)

        return data

    }
    catch (error) {
        console.log(error)
    }

}


function decrypt(text, key) {
    return String.fromCharCode(...text.match(/.{1,2}/g)
        .map((e, i) =>
            parseInt(e, 16) ^ key.charCodeAt(i % key.length) % 255)
    )
}


export const supaRegister = async (emails, passwords, nicknames, nome) => {
    if (!emails) {
        alert('Inserisci email')
        return
    }

    if (!passwords) {
        alert('Inserisci password')
        return
    }

    if (!nicknames) {
        alert('Inserisci nickname')
        return
    }

    if (!nome) {
        alert('Inserisci nome')
        return
    }


    const password = encrypt(passwords, "Passphrase")

    try {

        const { data, error } = await supabase
            .from('account')
            .insert(
                { mail: emails, password: password, nickname: nicknames, nome: nome },
            )
            .select()

        if (error) {
            throw error.details
        } else {
            alert('Account creato, aspetta che il direttivo ti attivi!')
        }
    }
    catch (error) {
        alert(error.details)
        console.log(error)
    }
}






export const getSchedule = async () => {
    try {
        const { data, error } = await supabase
            .from('schedule')
            .select()
        if (error) {
            throw error.details
        }
        else {
            return data
        }
    }
    catch (error) {
        console.log(error)
    }
}

export const getFutureSchedule = async () => {
    try {
        const { data, error } = await supabase
            .from('schedule')
            .select()
            .gt('date', new Date())
        if (error) {
            throw error.details
        }
        else {
            return data
        }
    }
    catch (error) {
        console.log(error)
    }
}


export const getSpecifySchedule = async (id) => {
    try {
        const { data, error } = await supabase
            .from('schedule')
            .select()
            .eq('id', id)
        if (error) {
            throw error.details
        }
        else {
            return data
        }
    }
    catch (error) {
        console.log(error)
    }
}


export const addMemberToSchedule = async (id, member) => {

    //member is a json
    try {
        const { data, error } = await supabase
            .from('schedule')
            .update({ member: member })
            .eq('id', id)
        if (error) {
            throw error.details
        }
        else {
            return data
        }
    }
    catch (error) {
        console.log(error)
    }

}

export const addPallini = async (id, member) => {
    try {
        const { data, error } = await supabase
            .from('schedule')
            .update({ pallini: member })
            .eq('id', id)
        if (error) {
            throw error.details
        }
        else {
            return data
        }
    }
    catch (error) {
        console.log(error)
    }
}

export const addPalliniPremium = async (id, pallini) => {
    try {
        const { data, error } = await supabase
            .from('schedule')
            .update({ pallini_premium: pallini })
            .eq('id', id)

        if (error) {
            console.error('Error updating pallini premium:', error)
            return null
        }

        return data
    } catch (error) {
        console.error('Error in addPalliniPremium:', error)
        return null
    }
}

export const getAccount = async (mail) => {
    try {
        const { data, error } = await supabase
            .from('account')
            .select()
            .eq('mail', mail)
        if (error) {
            throw error.details
        }
        else {
            return data
        }
    }
    catch (error) {
        console.log(error)
    }
}

export const postActivity = async (title,
    type,
    place,
    date,
    hour,
    meeting,
    info,
    end,
    setup,
    appointment) => {

    if (!title) {
        alert('Inserisci titolo')
        return
    }

    if (!type) {
        alert('Inserisci tipo')
        return
    }

    if (!place) {
        alert('Inserisci luogo')
        return
    }

    if (!date) {
        alert('Inserisci data')
        return
    }

    if (!hour) {
        alert('Inserisci ora')
        return
    }

    if (!meeting) {
        alert('Inserisci luogo incontro')
        return
    }

    if (!end) {
        alert('Inserisci ora fine')
        return
    }

    if (!setup) {
        alert('Inserisci setup')
        return
    }


    if (!appointment) {
        alert('Inserisci ora appuntamento')
        return
    }

    try {

        const hou = hour + ':00'
        const en = end + ':00'
        const app = appointment + ':00'


        const { data, error } = await supabase
            .from('schedule')
            .insert(
                {
                    title: title,
                    where: meeting,
                    date: date,
                    time: hou,
                    desc: info,
                    campo: place,
                    type: type,
                    end: en,
                    setup: setup,
                    appointment_hour: app,
                    member: [],
                    pallini: []
                }
            )
            .select()
        if (error) {
            alert('Attività non postata')
            throw error.details
        }
        else {
            alert('Attività postata')
            return data
        }
    }
    catch (error) {
        console.log(error)
    }
}

export const editActivity = async (id,
    title,
    type,
    place,
    date,
    hour,
    meeting,
    info,
    end,
    setup,
    appointment) => {
    try {

        const { data, error } = await supabase
            .from('schedule')
            .update({
                title: title,
                where: meeting,
                date: date,
                time: hour,
                desc: info,
                campo: place,
                type: type,
                end: end,
                setup: setup,
                appointment_hour: appointment,
            })
            .eq('id', id)
        if (error) {
            throw error.details
        }
        else {
            alert('Attività modificata')
            return data
        }
    }
    catch (error) {
        console.log(error)
    }

}


export const getAllAccount = async () => {
    try {
        const { data, error } = await supabase
            .from('account')
            .select()
        if (error) {
            throw error.details
        }
        else {
            return data
        }
    }
    catch (error) {
        console.log(error)
    }
}


export const revokeAdmin = async (mail, state) => {
    try {
        const { data, error } = await supabase
            .from('account')
            .update({ accepted: state })
            .eq('mail', mail)
        if (error) {
            throw error.details
        }
        else {
            return data
        }
    }
    catch (error) {
        console.log(error)
    }
}

export const updateAdminRole = async (mail, isAdmin) => {
    try {
        const { data, error } = await supabase
            .from('account')
            .update({ admin: isAdmin })
            .eq('mail', mail)
        if (error) {
            throw error.details
        }
        else {
            return data
        }
    }
    catch (error) {
        console.log(error)
    }
}

export const deleteAccount = async (mail) => {
    try {
        const { data, error } = await supabase
            .from('account')
            .delete()
            .eq('mail', mail)
        if (error) {
            throw error.details
        }
        else {
            alert('Account eliminato')
            return data
        }
    }
    catch (error) {
        console.log(error)
    }
}

export const deleteActivity = async (id) => {
    try {
        const { data, error } = await supabase
            .from('schedule')
            .delete()
            .eq('id', id)
        if (error) {
            throw error.details
        }
        else {
            alert('Attività eliminata')
            return data
        }
    }
    catch (error) {
        console.log(error)
    }
}

export const uploadImage = async (file) => {
    try {
        const { datas, error } = await supabase
            .storage
            .from('profile_image')
            .upload('file', file)
        if (error) {
            throw error.details
        }
        else {
            console.log(datas, 'image uploaded')
            //add image link to account table
            const { data, error } = await supabase
                .from('account')
                .update({ image: datas })
                .eq('mail', localStorage.getItem('mail'))
            if (error) {
                throw error.details
            }
            else {
                return data
            }
        }
    }
    catch (error) {
        console.log(error)
    }
}

export const deleteSchedule = async (id) => {
    try {
        const { data, error } = await supabase
            .from('schedule')
            .delete()
            .eq('id', id)
        if (error) {
            throw error.details
        }
        else {
            alert('Attività eliminata')
            return data
        }
    }
    catch (error) {
        console.log(error)
    }
}


export const updateAccountPresenze = async (mail, presenze) => {
    try {
        const { data, error } = await supabase
            .from('account')
            .update({ presenze: presenze })
            .eq('mail', mail)
    }

    catch (error) {


    }
}




export const addSegnalazioni = async (id, segnalazione, name) => {
    try {
        const { data, error } = await supabase
            .from('segnalazioni')
            .insert({ user_id: id, segnalazione: segnalazione, name: name })
        alert('Segnalazione creata')
    }
    catch (error) {
        alert('Segnalazione non creata')
    }
}


export const updateFondiToAccount = async (id, fondi) => {
    try {

        const {data, error} = await supabase
        .from('account')
        .update({ fondi: fondi })
        .eq('id', id)
    }
    catch (error) {
        alert('Fondi non aggiornati')
    }

}
